<main
  class="container"
  [ngClass]="{
    'pds-modular-header-info':
      userType === 'supplier' && survey.isPDSEnabled && survey.isModularSurvey,
    'pds-header-info':
      userType === 'supplier' && (survey.isPDSEnabled || survey.isModularSurvey)
  }"
>
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div
        class="survey-detail-back-btn"
        *ngIf="!survey.channelType; else TCParent"
      >
        <a (click)="navigateToDashboard()">
          <i class="fa fa-angle-left" aria-hidden="true"></i>Back to
          {{ surveyStatus[survey.status] }} Surveys</a
        >
        <a
          *ngIf="showInvoiceTab()"
          class="pull-right invoiceSurveyBtn"
          id="invoiceBtn"
          [class.disabled]="!isChildTCsClosed"
          (click)="invoiceSurvey()"
        >
          <div
            *ngIf="!isChildTCsClosed"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
          Invoice Survey
          <p id="wait-child-tcs">
            Waiting child traffic channels status change
          </p>
        </a>
        <a
          *ngIf="
            survey.status === surveyStatus.Invoice && userType !== 'supplier'
          "
          class="pull-right invocedSurvey"
        >
          Survey Invoiced
        </a>
      </div>
      <ng-template #TCParent>
        <div class="survey-detail-back-btn">
          <a
            routerLink="/dashboard/{{ survey.mcProjectId || survey.projectId }}"
          >
            <i class="fa fa-angle-left" aria-hidden="true"></i>Back to Surveys#
            {{ survey.mcProjectId || survey.projectId || '' }}
          </a>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="row survey-detail-header">
    <div class="col-md-6 survey-aida-container">
      <p>Survey# {{ survey.id }}</p>
      <div class="survey-status">
        <button
          e2e-data="survey-status-dropdown-btn"
          class="menu-btn"
          [psUiDropdownToggleFor]="surveysStatus"
          [disabled]="checkDisableSurveyStatus(survey)"
          [ngClass]="{
            greyOutInvoiceButton: survey.status === surveyStatus.Invoice
          }"
        >
          {{ surveyStatus[survey.status] }}
        </button>
        <span
          *ngIf="showScheduledBadge()"
          class="scheduled-badge d-inline-flex align-items-center text-capitalize"
        >
          {{ scheduledBadgeText }}
        </span>
        <ps-ui-dropdown class="status-dropdown" #surveysStatus="psUiDropdown">
          <div *ngFor="let statusButton of statusButtons">
            <button
              attr.e2e-data="survey-{{ statusButton.value?.toLowerCase() }}-btn"
              psUiDropdownItem
              *ngIf="statusButton.condition.indexOf(survey.status) > -1"
              (click)="openStatusModal(survey, statusButton.value)"
              id="status-button-{{ statusButton.value }}"
            >
              {{ statusButton.value }}
            </button>
          </div>
        </ps-ui-dropdown>
      </div>
      <div *ngIf="survey.aida?.enabled" class="aida-info-container">
        <div class="aida-info">
          <img
            class="aida-icon"
            src="./../../../../assets/image/blue-stars.svg"
            alt="Blue stars icon"
          />
          <p>
            <span class="aida-tm">AIDA&#8482;</span> (AI Delivery Assistant)
            Active
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-6 d-flex justify-content-end survey-country-dropdown">
      <div
        *ngIf="buyerSurvey.tracker?.enable"
        class="d-flex align-items-center flex-nowrap gap-1"
      >
        <ps-ui-flag
          [countryCode]="buyerSurvey.locale.country_code"
        ></ps-ui-flag>
        <span class="d-flex align-items-center text-nowrap">
          {{ buyerSurvey.locale.country_name }}
          <span class="p-1 fw-bold language-icon ms-2">
            {{ buyerSurvey.locale.language_translate | uppercase }}
          </span>
        </span>
        <div class="dropdown-wrapper ms-4">
          <ps-ui-select-dropdown
            [disabled]="!buyerSurvey.tracker?.surveys?.length"
            [loading]="false"
            [dropdownItems]="buyerSurvey.tracker?.surveys || []"
            [field]="'wave_id'"
            [clearSearch]="false"
            [enableSearch]="false"
            class="uppercase"
            [labelNone]="
              this.selectedTrackerWave.wave_id.toString() || 'Select Wave'
            "
            labelAlignment="start"
            [(ngModel)]="selectedTrackerWave"
            (selectedItem)="selectTrackerWave($event)"
          >
            <i class="fa fa-clock-o fa-lg me-2" label-prefix-element></i>
            <span label-prefix-element>Wave</span>

            <ng-template #dropdownItemLabelPrefix>
              <i class="fa fa-clock-o fa-lg me-2"></i>
              <span>Wave</span>
            </ng-template>
          </ps-ui-select-dropdown>
        </div>
      </div>
      <div
        *ngIf="!buyerSurvey.tracker?.enable && buyerSurvey.mc?.SVP"
        class="country-select-dropdown"
      >
        <ps-ui-select-dropdown
          [disabled]="!buyerSurvey.mc.surveys?.length"
          [loading]="false"
          [dropdownItems]="buyerSurvey.mc.surveys || []"
          [field]="'countryName'"
          [showFlag]="true"
          [flagCountryCodeField]="'countryCode'"
          [flagLanguageCodeField]="'languageCode'"
          [clearSearch]="false"
          [enableSearch]="false"
          class="uppercase"
          [labelNone]="this.selectedSvpCountry.countryName || 'Select Country'"
          labelAlignment="start"
          [(ngModel)]="selectedSvpCountry"
          (selectedItem)="selectSvpCountry($event)"
          attr.data-e2e="country-dropdown-{{ survey.id }}"
        >
        </ps-ui-select-dropdown>
      </div>
      <ps-ui-flag
        *ngIf="!buyerSurvey.mc?.SVP"
        class="pull-right"
        [countryCode]="survey.countryCode"
        [countryName]="survey.countryName"
      ></ps-ui-flag>
    </div>
  </div>

  <div
    class="survey-title-content d-flex align-items-center justify-content-between gap-4"
  >
    <h2 class="mb-0">{{ survey.title }}</h2>
    <ng-template [ngIf]="surveyScore && shouldShowSurveyScoreBadge()">
      <ps-ui-survey-score-badge
        [surveyScore]="surveyScore"
        type="scorePercentageWithTitle"
      ></ps-ui-survey-score-badge>
    </ng-template>
  </div>
  <ps-ui-survey-top-view
    [survey]="survey"
    [userRole]="userType"
  ></ps-ui-survey-top-view>
  <ps-aida-quota-performance-tile
    [status]="aidaQuotaHealth?.status"
    [aidaEnabled]="survey.aida?.enabled || false"
  ></ps-aida-quota-performance-tile>
  <div class="row">
    <!-- Quota Tab needs to modify for supplier, Curently working for only buyer -->
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <ng-container *ngIf="!isEmptySurvey()">
        <ps-ui-manage-survey-tabs
          [survey]="survey"
          [auth]="auth"
          [targetedActiveTabKey]="activeSurveyDashboardTabKey"
          [selectedChildSurveyId]="selectedChildSurveyId"
          [aidaQuotaHealth]="aidaQuotaHealth"
          (surveyScoreEmitter)="receiveSurveyScore($event)"
        ></ps-ui-manage-survey-tabs>
      </ng-container>
    </div>
  </div>
</main>
<ps-edit-survey-footer
  *ngIf="userType !== 'supplier' && !isEmptySurvey() && !isMasterMultiBuyer"
  [surveyId]="surveyId"
  [surveyChannelType]="survey.channelType"
  [survey]="buyerSurvey"
  [selectedSvpCountry]="selectedSvpCountry"
  [isQbpChildSurvey]="isQbpChildSurvey"
  [isRecontact]="isRecontact"
  [st]="survey.status"
></ps-edit-survey-footer>
